<div class="p-6 bg-slate-50 dark:bg-slate-900 min-h-screen">
  <!-- Header with title and controls -->
  <header class="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between mb-6">
    <h3
      class="font-['Lato',sans-serif] text-[20px] font-bold tracking-[-0.4px] text-slate-900 dark:text-white capitalize normal-case m-0">
      Enrollment & Activation</h3>
    <div class="flex items-center gap-3 flex-wrap justify-end">
      <app-date-picker [size]="'md'" (valueChange)="rangeValues($event)" (dateRangeChange)="onDateRangeChange($event)"
        [showComparison]="true" [showGroupBy]="true" [allowedGroupByUnits]="allowedGroupByUnits">
      </app-date-picker>
      <!-- <div class="w-[250px]">
        <app-dropdown [options]="currencyOptions" [ngModel]="selectedCurrency()"
          (ngModelChange)="onCurrencyChange($any($event))" [placeholder]="'Currency'" [selectionMode]="'single'"
          [selectionStyle]="'none'" [type]="'selection'" [maxHeight]="'240px'" [size]="'md'">
        </app-dropdown>
      </div> -->
    </div>
  </header>
  <!-- Enrollment & activation content -->
  <div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 relative">
      @if (isChartsLoading()) { <app-individual-toaster></app-individual-toaster> }
      <!-- Businesses Enrolled KPI -->
      <div
        class="bg-gradient-to-r from-purple-50/50 to-white dark:from-purple-900/20 dark:to-gray-800 rounded-lg p-4 shadow-sm border border-gray-100 dark:border-gray-700">
        <div class="flex justify-between items-start mb-2">
          <h4 class="text-[11px] font-[600] text-[#6a7c93] uppercase">Businesses Enrolled</h4>
          <span class="text-[9.5px]  font-bold  px-2 py-1 rounded-full"
            [ngClass]="enrolledBusinessesSignal().mom > 0 ? 'bg-slate-100 dark:bg-slate-50 text-slate-600' : enrolledBusinessesSignal().mom < 0 ? 'bg-purple-100 dark:bg-purple-50 text-purple-700' : 'bg-emerald-100 dark:bg-emerald-50 text-emerald-500'">{{
            enrolledBusinessesSignal().mom > 0 ?
            'LEADING' : enrolledBusinessesSignal().mom == 0 ? 'STABLE' : 'LAGGING' }}</span>
        </div>
        <div class="text-[26px] font-bold tracking-[-1px] text-slate-900 dark:text-white mb-1 leading-none">{{
          enrolledBusinessesSignal().value | number }}</div>
        <div class="text-[11px] flex items-center gap-1 font-medium mt-4"
          [ngClass]="enrolledBusinessesSignal().mom > 0 ? 'text-emerald-600' : enrolledBusinessesSignal().mom < 0 ? 'text-red-600' : 'text-orange-500'">
          <div class="w-1.5 h-1.5 rounded-full"
            [ngClass]="enrolledBusinessesSignal().mom > 0 ? 'bg-emerald-600' : enrolledBusinessesSignal().mom < 0 ? 'bg-red-600' : 'bg-orange-500'">
          </div>
          MoM {{ enrolledBusinessesSignal().momText }}
        </div>
      </div>

      <!-- Businesses with a Contract KPI -->
      <div
        class="bg-gradient-to-r from-purple-50/80 to-white dark:from-purple-900/30 dark:to-gray-800 rounded-lg p-4 shadow-sm border border-gray-100 dark:border-gray-700 relative overflow-hidden">
        <!-- Gradient Left Border -->
        <div class="absolute top-0 left-0 bottom-0 w-1 bg-gradient-to-b from-[#9333EA] to-[#3B82F6]"></div>

        <div class="flex justify-between items-start mb-2">
          <h4 class="text-[11px] font-[600] text-[#6a7c93] uppercase">Businesses With a Contract</h4>
          <span
            class="text-[10px] font-bold uppercase tracking-wider bg-purple-50 text-purple-700 px-2 py-0.5 rounded">ACTIVATION</span>
        </div>
        <div class="text-[26px] font-bold tracking-[-1px] text-slate-900 dark:text-white mb-1 leading-none">{{
          businessesWithContractSignal().value | number }}</div>
        <div class="text-[11.5px] leading-[1.45] text-slate-500  mb-3">
          Of {{ enrolledBusinessesSignal().value | number }} enrolled · {{ businessesWithContractSignal().toConvert |
          number }} have no contract yet
        </div>

        <!-- Progress bar -->
        <div class="w-full bg-gray-100 rounded-full h-1.5 mb-1.5 dark:bg-gray-700 overflow-hidden">
          <div class="bg-gradient-to-r from-[#9333EA] to-[#3B82F6] h-1.5 rounded-full"
            [style.width.%]="businessesWithContractSignal().goalPct"></div>
        </div>
      </div>
    </div>

    <!-- Charts Section -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8 relative">
      @if (isChartsLoading()) { <app-individual-toaster></app-individual-toaster> }
      <!-- Chart 1: Enrolled vs Contracts Created -->
      <div
        class="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-slate-100 dark:border-slate-700 p-4 flex flex-col">
        <div class="mb-4">
          <h3 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white ">Enrolled vs Active Businesses
          </h3>
          <!-- <p class="text-[11.5px] text-[#6a7c93] dark:text-slate-400 mt-[3px] leading-[1.4]">Where enrollment outruns
            active business, activation is leaking</p> -->
        </div>
        <div class="w-full h-[220px]">
          @if (chart1Data().length) {
          <div class="w-full h-full relative overflow-x-auto overflow-y-hidden custom-scrollbar">
            <div [style.min-width.px]="getAllTimeChartMinWidth(chart1Data().length)" class="h-full w-full">
              <app-bar-line [data1]="chart1Data()" [lines]="chart1Lines" [legendData]="chart1Legend"
                [colors]="chart1Colors" [tooltipData]="chart1Tooltip" [valueKey]="'enrolled'" [valueType]="''"
                [rightAxisType]="'number'" [leftAxisLabel]="'Enrolled'" [rightAxisLabel]="'Active Businesses'"
                [rightAxisLabelOffset]="35" [margin]="{ top: 20, right: 50, bottom: 40, left: 65 }" [labelKey]="'start'"
                [showBackground]="false" [barTextposition]="'none'" [formatDateXAxis]="true" [unit]="unit()"
                [xAxisShowOnlyFirstLast]="true" [formatKM]="false" [removeYearInXAxis]="is90DaysSelected()">
              </app-bar-line>
            </div>
          </div>
          } @else {
          <div class="flex flex-col items-center justify-center h-full text-slate-400">
            <p class="text-sm">No data available</p>
          </div>
          }
        </div>
      </div>

      <!-- Chart 2: Contracts & Financed Amount -->
      <div
        class="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-slate-100 dark:border-slate-700 p-4 flex flex-col">
        <h3 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">Contracts & Financed Amount</h3>
        <!-- <p class="text-[11.5px] text-[#6a7c93] dark:text-slate-400 mt-[3px] leading-[1.4]">Volume (bars) against
          financed dollars (line)</p> -->
        <div class="w-full h-[220px]">
          @if (chart2Data().length) {
          <div class="w-full h-full relative overflow-x-auto overflow-y-hidden custom-scrollbar">
            <div [style.min-width.px]="getAllTimeChartMinWidth(chart2Data().length)" class="h-full w-full">
              <app-bar-line [data1]="chart2Data()" [lines]="chart2Lines" [legendData]="chart2Legend"
                [colors]="chart2Colors" [tooltipData]="chart2Tooltip" [valueKey]="'contracts'" [valueType]="''"
                [rightAxisType]="'number'" [leftAxisLabel]="'Contracts'" [rightAxisLabel]="'Financed Amount'"
                [rightAxisLabelOffset]="65" [margin]="{ top: 20, right: 80, bottom: 40, left: 65 }" [labelKey]="'start'"
                [showBackground]="false" [barTextposition]="'none'" [formatDateXAxis]="true" [unit]="unit()"
                [xAxisShowOnlyFirstLast]="true" [formatKM]="true" [removeYearInXAxis]="is90DaysSelected()">
              </app-bar-line>
            </div>
          </div>
          } @else {
          <div class="flex flex-col items-center justify-center h-full text-slate-400">
            <p class="text-sm">No data available</p>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  <!-- Proposal conversion -->
  <section class="mt-8">
    <div
      class="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-slate-100 dark:border-slate-700 p-4 flex flex-col relative overflow-hidden">
      @if (isChartsLoading()) { <app-individual-toaster></app-individual-toaster> }
      <h3 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">Proposal Conversion</h3>
      <p class="text-[12px] text-slate-500 dark:text-slate-400 mt-[3px] mb-4 font-normal">
        {{ proposalConversionSent() | number }} sent &mdash; {{ proposalConversionOpened() | number }} opened ({{
        proposalConversionOpenedPct() }}%) &mdash; {{ proposalConversionSelected() | number }} plans selected &mdash; {{
        proposalConversionFinanced() | number }} financed ({{ proposalConversionSentToFinancedPct() }}%
        sent-to-financed)
      </p>
      <div class="w-full min-h-[220px]">
        @if (proposalConversionChartData().length) {
        <app-horizontal-bar-chart [data]="proposalConversionChartData()" [showXAxisGrid]="false"
          [showXAxisLabel]="false" [showYAxisLine]="false" [colorYAxisLabels]="false" [barHeight]="26"
          [barPadding]="0.4" [roundedCorners]="true" [cornerRadius]="6" [leftMargin]="140" [maxLabelWidth]="140"
          [yAxisTickPadding]="12" [minHeight]="220" [valueType]="'number'" [showBarsValue]="true" class="w-full block">
        </app-horizontal-bar-chart>
        } @else {
        <div class="flex flex-col items-center justify-center h-full text-slate-400 py-12">
          <p class="text-sm">No data available</p>
        </div>
        }
      </div>
    </div>
  </section>
  <!-- Proposal conversion end -->

  <!-- ─────────────── Geography & Industry ───────────────────────────────────── -->
  <section class="mt-8">
    <div class="mb-4">
      <div class="flex items-end justify-between">
        <h1
          class="font-['Lato',sans-serif] text-[20px] font-bold tracking-[-0.4px] text-slate-900 dark:text-white capitalize normal-case">
          Geography & Industry</h1>
      </div>
    </div>

    <!-- Cards -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 relative">
      @if (isGeoLoading()) { <app-individual-toaster></app-individual-toaster> }
      <!-- Geographic Concentration -->
      <div
        class="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-4 shadow-sm relative overflow-hidden">
        <div class="flex items-center justify-between mb-2 relative z-10">
          <span class="text-[10px] font-bold uppercase tracking-widest text-slate-500">Geographic Concentration</span>
          <span
            class="text-[10px] font-bold uppercase tracking-wider bg-slate-100 text-slate-700 dark:bg-slate-700/50 dark:text-slate-300 px-2.5 py-0.5 rounded-full">Top
            3 Markets</span>
        </div>
        <div class="text-[28px] font-bold mb-1 text-slate-900 dark:text-white tabular-nums relative z-10 leading-none">
          {{ geoConcentration().topPercentage }}%
        </div>
        <p class="mt-1 text-[11.5px] leading-[1.45] text-slate-500 mt-[7px] dark:text-slate-400 relative z-10">
          <!-- {{ geoConcentration().top2Text }} · {{ geoConcentration().spread }}% spread across {{ geoConcentration().emerging }} emerging
          markets<br> -->
          #1 {{ geoConcentration().topMarket }}: {{ geoConcentration().topCount | number }}
          contracts ({{
          geoConcentration().top1Percentage }}% of global)
        </p>
      </div>

      <!-- Portfolio Signal -->
      <div
        class="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-4 shadow-sm relative overflow-hidden">
        <div class="flex items-center justify-between mb-2 relative z-10">
          <span class="text-[10px] font-bold uppercase tracking-widest text-slate-500">Portfolio Signal</span>
          <span
            class="text-[10px] font-bold uppercase tracking-wider bg-orange-50 text-orange-600 dark:bg-orange-500/10 dark:text-orange-400 px-2.5 py-0.5 rounded-full">Expand</span>
        </div>
        <div
          class="text-[28px] font-bold mb-1 text-slate-900 dark:text-white tabular-nums flex items-center gap-2 relative z-10 leading-none">
          {{ portfolioSignal().market }}
          @if (portfolioSignal().growth > 0) {
          <span class="text-emerald-500">↑</span>
          } @else if (portfolioSignal().growth < 0) { <span class="text-red-500">↓</span>
            }
        </div>
        <p class="mt-1 text-[11.5px] leading-[1.45] text-slate-500 mt-[7px] dark:text-slate-400 relative z-10">
          Accelerate lower-share markets to reduce single-market dependency.<br>
          @if (portfolioSignal().growth) {
          <span class="text-slate-400 font-medium">(Growth: {{ portfolioSignal().growth | number:'1.0-1' }}%)</span>
          }
        </p>
      </div>
    </div>

    <!-- Map Section -->
    <div
      class="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-100 dark:border-slate-700 p-6 flex flex-col relative overflow-hidden">
      @if (isGeoLoading()) { <app-individual-toaster></app-individual-toaster> }

      <div class="flex flex-col md:flex-row md:justify-between md:items-start mb-6 relative z-10 gap-4">
        <div>
          <h3 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">Geographic Distribution</h3>
          <p class="text-[11.5px] leading-[1.45] text-slate-500 dark:text-slate-400 mt-[7px]">12-country coverage
            &middot; click any region for a market
            deep-dive</p>
        </div>

        <div class="flex items-center gap-2 self-start md:self-auto pt-1">
          <span class="w-2 h-2 rounded-full bg-purple-600"></span>
          <span class="text-xs font-semibold text-slate-700 dark:text-slate-300">Current: <span
              class="font-bold text-slate-900 dark:text-white">{{ currentMapTotal() | number }}</span></span>
        </div>
      </div>

      <div class="flex flex-wrap items-center gap-6 mb-6 relative z-10">
        <!-- Metric Toggle -->
        <div class="flex flex-col items-start gap-1.5">
          <span class="text-[10px] font-bold uppercase tracking-widest text-slate-500">Metric</span>
          <div
            class="flex bg-white dark:bg-slate-900/50 rounded-lg border border-slate-200 dark:border-slate-700 p-0.5">
            <button (click)="setGeoMetricMode('biz')"
              [class]="geoMetricMode() === 'biz' ? 'bg-[#9333EA] text-white shadow-sm' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'"
              class="px-4 py-1.5 rounded-md text-[13px] font-medium transition-colors duration-200">Businesses</button>
            <button (click)="setGeoMetricMode('con')"
              [class]="geoMetricMode() === 'con' ? 'bg-[#9333EA] text-white shadow-sm' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'"
              class="px-4 py-1.5 rounded-md text-[13px] font-medium transition-colors duration-200">Contracts</button>
          </div>
        </div>

        <!-- Industry Toggle -->
        <div class="flex flex-col items-start gap-1.5">
          <span class="text-[10px] font-bold uppercase tracking-widest text-slate-500">Industry</span>
          <div
            class="flex bg-white dark:bg-slate-900/50 rounded-lg border border-slate-200 dark:border-slate-700 p-0.5">
            <button (click)="setGeoIndustryMode('0')"
              [class]="geoIndustryMode() === '0' ? 'bg-[#9333EA] text-white shadow-sm' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'"
              class="px-4 py-1.5 rounded-md text-[13px] font-medium transition-colors duration-200">Total</button>
            <button (click)="setGeoIndustryMode('1')"
              [class]="geoIndustryMode() === '1' ? 'bg-[#9333EA] text-white shadow-sm' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'"
              class="px-4 py-1.5 rounded-md text-[13px] font-medium transition-colors duration-200">Dental</button>
            <button (click)="setGeoIndustryMode('2')"
              [class]="geoIndustryMode() === '2' ? 'bg-[#9333EA] text-white shadow-sm' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'"
              class="px-4 py-1.5 rounded-md text-[13px] font-medium transition-colors duration-200">Healthcare</button>
            <button (click)="setGeoIndustryMode('3')"
              [class]="geoIndustryMode() === '3' ? 'bg-[#9333EA] text-white shadow-sm' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'"
              class="px-4 py-1.5 rounded-md text-[13px] font-medium transition-colors duration-200">Non-HC</button>
          </div>
        </div>
      </div>

      <!-- Map -->
      <div
        class="w-full h-[400px] bg-slate-50 dark:bg-slate-900/20 rounded-xl overflow-hidden relative border border-slate-100 dark:border-slate-700/50">
        @if (mapData().length > 0) {
        <app-geographic-map class="block w-full h-full" [stateData]="mapData()" [valueKeys]="mapValueKeys()"
          (regionClick)="onRegionClick($event)">
        </app-geographic-map>
        } @else {
        <div class="flex flex-col items-center justify-center h-full text-slate-400">
          <p class="text-sm">No map data available</p>
        </div>
        }

        <div
          class="absolute bottom-4 left-6 text-[10px] text-slate-500 font-medium bg-white/80 dark:bg-slate-800/80 px-2 py-1 rounded">
          106 states - click any state for details
        </div>
      </div>
    </div>

    <!-- Industry Top Categories & Risk Quadrant -->
    <div class="grid grid-cols-1 xl:grid-cols-2 gap-4 mt-4 relative">
      @if (isIndustryLoading()) { <app-individual-toaster fontSize="16px" /> }
      <!-- Top Categories Bar Chart -->
      <div
        class="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-4 shadow-sm relative overflow-hidden flex flex-col">
        <div class="mb-3">
          <h3 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">Top Categories By Contracts</h3>
          <p class="text-[11.5px] leading-[1.45] text-slate-500 dark:text-slate-400 mt-[3px]">Switch the vertical to see
            its leading categories</p>
        </div>

        <div class="mb-0.1">
          <span class="text-[10px] font-bold uppercase tracking-widest text-slate-500 mb-1.5 block">VERTICAL</span>
          <div
            class="flex items-center gap-2 border border-[#e3eaf4] bg-[#f6f9fe] dark:bg-slate-900/50 dark:border-slate-700 rounded-[10px] p-1 ">
            <button (click)="setVerticalMode('0')"
              [class]="selectedVertical() === '0' ? 'bg-[#8A2BE2] text-white shadow-sm' : 'text-slate-600 hover:text-slate-900'"
              class="px-4 py-1 rounded-[7px] text-[11px] font-semibold transition-colors duration-200">Dental</button>
            <button (click)="setVerticalMode('1')"
              [class]="selectedVertical() === '1' ? 'bg-[#8A2BE2] text-white shadow-sm' : 'text-slate-600 hover:text-slate-900'"
              class="px-4 py-1 rounded-[7px] text-[11px] font-semibold transition-colors duration-200">Healthcare</button>
            <button (click)="setVerticalMode('2')"
              [class]="selectedVertical() === '2' ? 'bg-[#8A2BE2] text-white shadow-sm' : 'text-slate-600 hover:text-slate-900'"
              class="px-4 py-1 rounded-[7px] text-[11px] font-semibold transition-colors duration-200">Non-HC</button>
          </div>
        </div>

        <div class="h-[250px] w-full mt-auto">
          @if (topCategoriesData().length > 0) {
          <app-bar-line [data1]="topCategoriesData()" [colors]="categoryChartColors"
            [tooltipData]="categoryChartTooltip" [labelKey]="'category'" [tooltipHeaderKey]="'fullCategory'"
            [valueKey]="'data1'" [showBackground]="false" [barTextposition]="'none'"
            [margin]="{ top: 20, right: 5, bottom: 30, left: 35 }" [valueType]="''">
          </app-bar-line>
          } @else {
          <div class="flex items-center justify-center h-full text-slate-400 text-sm">No data available</div>
          }
        </div>
      </div>

      <!-- Risk Quadrant -->
      <div
        class="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-4 shadow-sm relative overflow-hidden flex flex-col">
        <div class="mb-3">
          <h3 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">Industry Risk Quadrant</h3>
          <p class="text-[11.5px] leading-[1.45] text-slate-500 dark:text-slate-400 mt-[3px]">Unit profit against
            overdue
            risk · credit & sales decisions</p>
        </div>

        <!-- Quadrant Grid Container -->
        <div class="relative flex-grow flex flex-col pt-1 pl-8 pb-8 pr-1">

          <!-- Axis Labels -->
          <div class="absolute left-0 top-1/2 -translate-y-1/2 w-8 h-full flex items-center justify-center">
            <div
              class="origin-center -rotate-90 whitespace-nowrap text-[10px] font-bold uppercase tracking-widest text-slate-500 flex items-center gap-1">
              HIGHER UNIT PROFIT <span class="text-lg leading-none">→</span>
            </div>
          </div>
          <div
            class="absolute bottom-3 left-1/2 -translate-x-1/2 whitespace-nowrap text-[10px] font-bold uppercase tracking-widest text-slate-500 flex items-center gap-1">
            HIGHER OVERDUE RISK <span class="text-lg leading-none">→</span>
          </div>

          <!-- The 2x2 Grid -->
          <div class="grid grid-cols-2 grid-rows-2 gap-2 w-full h-full">

            <!-- Q1: High Profit, Low Risk (Top Left) -->
            <div
              class="bg-[#e6f6ec] dark:bg-emerald-900/20 border border-[#c7e8d1] dark:border-emerald-800/30 rounded-lg p-3 h-[120px] flex flex-col">
              <div class="text-emerald-700 dark:text-emerald-400 text-[11px] font-bold mb-1.5 flex items-center gap-1">
                ✓ High profit · Low risk
              </div>
              <div class="flex-grow overflow-hidden flex flex-col gap-1">
                @for (item of riskQuadrantData().q1; track item.name) {
                <div class="text-[11px] text-slate-600 dark:text-slate-300 truncate">
                  {{item.name}} (${{item.profit | number:'1.0-0'}})
                  <!-- , {{item.risk | number:'1.0-0'}} -->
                </div>
                }
                @if (!riskQuadrantData().q1.length) { <p
                  class="text-[12.5px] text-slate-600 dark:text-slate-400 font-medium mt-4">No data available</p> }
              </div>
            </div>

            <!-- Q2: High Profit, High Risk (Top Right) -->
            <div
              class="bg-[#fbe7e7] dark:bg-red-900/20 border border-[#f3cccc] dark:border-red-800/30 rounded-lg p-3 h-[120px] flex flex-col">
              <div class="text-red-700 dark:text-red-400 text-[11px] font-bold mb-1.6 flex items-center gap-1">
                ⚠ High profit · High risk
              </div>
              <div class="flex-grow overflow-hidden flex flex-col gap-1">
                @for (item of riskQuadrantData().q2; track item.name) {
                <div class="text-[11px] text-slate-600 dark:text-slate-300 truncate">
                  {{item.name}} (${{item.profit | number:'1.0-0'}})
                </div>
                }
                @if (!riskQuadrantData().q2.length) { <p
                  class="text-[12.5px] text-slate-600 dark:text-slate-400 font-medium mt-4">No data available</p> }
              </div>
            </div>

            <!-- Q3: Moderate Profit, Med Risk (Bottom Left) -->
            <div
              class="bg-purple-50 dark:bg-purple-900/20 border border-purple-100 dark:border-purple-800/30 rounded-lg p-3 h-[120px] flex flex-col">
              <div class="text-purple-700 dark:text-purple-400 text-[11px] font-bold mb-1.5 flex items-center gap-1">
                ● Moderate · Med risk
              </div>
              <div class="flex-grow overflow-hidden flex flex-col gap-1">
                @for (item of riskQuadrantData().q3; track item.name) {
                <div class="text-[11px] text-slate-600 dark:text-slate-300 truncate">
                  {{item.name}} (${{item.profit | number:'1.0-0'}})
                </div>
                }
                @if (!riskQuadrantData().q3.length) { <p
                  class="text-[12.5px] text-slate-600 dark:text-slate-400 font-medium mt-4">No data available</p> }
              </div>
            </div>

            <!-- Q4: Low Profit, High Risk (Bottom Right) -->
            <div
              class="bg-orange-50 dark:bg-orange-900/20 border border-orange-100 dark:border-orange-800/30 rounded-lg p-3 h-[120px] flex flex-col">
              <div class="text-orange-700 dark:text-orange-400 text-[11px] font-bold mb-1.5 flex items-center gap-1">
                X High overdue risk
              </div>
              <div class="flex-grow overflow-hidden flex flex-col gap-1">
                @for (item of riskQuadrantData().q4; track item.name) {
                <div class="text-[11px] text-slate-600 dark:text-slate-300 truncate">
                  {{item.name}} (${{item.profit | number:'1.0-0'}})
                </div>
                }
                @if (!riskQuadrantData().q4.length) { <p
                  class="text-[12.5px] text-slate-600 dark:text-slate-400 font-medium mt-4">No data available</p> }
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </section>

  <!-- Contract Portfolio Section -->
  <section class="mt-8">
    <div class="mb-6">
      <h1
        class="font-['Lato',sans-serif] text-[20px] font-bold tracking-[-0.4px] text-slate-900 dark:text-white capitalize normal-case">
        Contract Portfolio</h1>
    </div>

    <!-- Cards Container -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 relative">
      @if (isRetentionLoading()) { <app-individual-toaster></app-individual-toaster> }

      <!-- Card 1: Anchor risk -->
      <div
        class="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-3 shadow-sm relative overflow-hidden flex flex-col border-l-[4px] border-l-[#DC2626]">
        <div class="flex items-center gap-2 mb-2 text-[#DC2626]">
          <div class="w-2 h-2 rounded-full bg-[#DC2626]"></div>
          <h3 class="text-[10px] font-bold uppercase tracking-wider">Anchor Risk</h3>
        </div>

        <p class="text-[13px] text-slate-900 dark:text-white mb-3 leading-snug">
          <span class="font-bold">{{ anchorRisk().topBusinessName }}</span> carries <span class="font-bold">{{
            anchorRisk().topBusinessContracts }}</span> contracts and the
          top {{ anchorRisk().topAccountsCount }} accounts hold <span class="font-bold">{{
            anchorRisk().topAccountsSharePct }}%</span> of book — concentration risk.
        </p>

        <div class="border-t border-dashed border-slate-200 dark:border-slate-700 my-3"></div>

        <div class="mb-3 flex-grow">
          <h4 class="text-[9.5px] font-[700] tracking-[0.7px] text-slate-500 uppercase mb-[5px]">ACTION</h4>
          <p class="text-[12.5px] leading-[1.5] text-slate-600 dark:text-slate-400 mb-0">
            Onboard additional Dental anchor accounts before any contract expansion at {{ anchorRisk().topBusinessName
            }}.
          </p>
        </div>
      </div>

      <!-- Card 2: Disengaged accounts -->
      <div
        class="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-3 shadow-sm relative overflow-hidden flex flex-col border-l-[4px] border-l-[#F97316]">
        <div class="flex items-center gap-2 mb-2 text-[#D97706] dark:text-[#F97316]">
          <div class="w-2 h-2 rounded-full bg-[#F97316]"></div>
          <h3 class="text-[10px] font-bold uppercase tracking-wider">Disengaged Accounts</h3>
        </div>

        <p class="text-[13px] text-slate-900 dark:text-white mb-3 leading-snug">
          <span class="font-bold">{{ disengagedAccounts().dndCount }} contracts ({{ disengagedAccounts().dndPct }}%)
          </span>are flagged DND — disengaged and at elevated churn &
          late-payment risk.
        </p>

        <div class="border-t border-dashed border-slate-200 dark:border-slate-700 my-3"></div>

        <div class="mb-3 flex-grow">
          <h4 class="text-[9.5px] font-[700] tracking-[0.7px] text-slate-500 uppercase mb-[5px]">ACTION</h4>
          <p class="text-[12.5px] leading-[1.5] text-slate-600 dark:text-slate-400 mb-0">
            Launch a re-engagement outreach (preferred channel + offer) before these slip into overdue.
          </p>
        </div>
      </div>

      <!-- Card 3: Plan Velocity -->
      <div
        class="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-3 shadow-sm relative overflow-hidden flex flex-col border-l-[4px] border-l-[#059669]">
        <div class="flex items-center gap-2 mb-2 text-[#059669]">
          <div class="w-2 h-2 rounded-full bg-[#059669]"></div>
          <h3 class="text-[10px] font-bold uppercase tracking-wider">Plan Velocity</h3>
        </div>

        <p class="text-[13px] text-slate-900 dark:text-white mb-3 leading-snug">
          <span class="font-bold">{{contractTypesCountData().highestCount | number}}</span> of <span
            class="font-bold">{{contractTypesCountData().total | number}} </span>contracts are on <span
            class="font-bold">{{contractTypesCountData().highestLabel}}</span>
          ({{contractTypesCountData().highestPercentage}}%) — fast cash-in motion.
        </p>

        <div class="border-t border-dashed border-slate-200 dark:border-slate-700 my-3"></div>

        <div class="mb-3 flex-grow">
          <h4 class="text-[9.5px] font-[700] tracking-[0.7px] text-slate-500 uppercase mb-[5px]">ACTION</h4>
          <p class="text-[12.5px] leading-[1.5] text-slate-600 dark:text-slate-400 mb-0">
            Promote <span class="font-semibold">{{contractTypesCountData().highestLabel}}</span> the default plan in
            onboarding — proven
            low-friction.
          </p>
        </div>

      </div>
    </div>

    <!-- Status Trends & State Summary Section -->
    <div class="grid grid-cols-1 xl:grid-cols-2 gap-4 mt-4 relative">
      @if (isChartLoading() || isTableLoading()) { <app-individual-toaster></app-individual-toaster> }
      <!-- Chart Card -->
      <div
        class="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-4 shadow-sm relative overflow-hidden flex flex-col min-h-[340px]">
        <div class="mb-3">
          <h3 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white flex items-center gap-2">
            Contract Status Trends
          </h3>
          <p class="text-[13px] text-slate-500 mt-[4px] mb-[13px]">Contract status across all stages {{
            formattedDateRange }}
          </p>
        </div>

        <div class="flex-grow w-full relative min-h-[300px] flex flex-col pb-8">
          @if (contractStatusTrends().length > 0) {
          <app-multi-stacked-bar-chart [data]="contractStatusTrends()" [legendData]="statusChartLegend"
            [showLegend]="true" [showYAxis]="true" [showOnlyFirstLastXAxis]="true" [showXAxis]="true">
          </app-multi-stacked-bar-chart>
          } @else if (!isChartLoading()) {
          <div class="absolute inset-0 flex items-center justify-center text-slate-400 text-sm">
            No data available
          </div>
          }
        </div>
      </div>

      <!-- Table Card -->
      <div
        class="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-4 shadow-sm relative overflow-hidden flex flex-col min-h-[340px]">
        <div class="mb-3">
          <h3 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white flex items-center gap-2">
            Contract State Summary
          </h3>
          <p class="text-[13px] text-slate-500 mt-[4px] mb-[13px]">{{ contractStateHeadline() }}
          </p>
        </div>

        <div class="overflow-x-auto">
          <table class="w-full text-left border-collapse">
            <thead>
              <tr class="border-b border-slate-200 dark:border-slate-700">
                <th class="py-2 px-3 text-[11px] font-semibold text-slate-500 uppercase tracking-wider">State</th>
                <th class="py-2 px-3 text-[11px] font-semibold text-slate-500 uppercase tracking-wider">Count</th>
                <th class="py-2 px-3 text-[11px] font-semibold text-slate-500 uppercase tracking-wider">% of Book</th>
                <th class="py-2 px-3 text-[11px] font-semibold text-slate-500 uppercase tracking-wider">Signal</th>
              </tr>
            </thead>
            <tbody>
              @for (row of contractStateSummary(); track row.state; let i = $index) {
              <tr
                class="border-b border-slate-100 dark:border-slate-700/50 hover:bg-slate-50 dark:hover:bg-slate-800/80 transition-colors">
                <td class="py-2 px-3 text-[13px] text-slate-900 dark:text-white font-medium">{{row.state}}</td>
                <td class="py-2 px-3 text-[13px] text-slate-700 dark:text-slate-300">{{row.count | number}}</td>
                <td class="py-2 px-3 text-[13px] text-slate-700 dark:text-slate-300">{{row.pct | number:'1.1-2'}}%</td>
                <td class="py-2 px-3 text-[13px] font-semibold {{row.signal.colorClass}}">{{row.signal.text}}</td>
              </tr>
              }
            </tbody>
          </table>
          @if (!isTableLoading() && contractStateSummary().length === 0) {
          <div class="py-8 text-center text-slate-400 text-sm">
            No summary data available
          </div>
          }
        </div>
      </div>
    </div>

    <!-- Revenue Stream Mix Section -->
    <div class="grid grid-cols-1 mt-4">
      <div
        class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-5 shadow-sm relative overflow-hidden flex flex-col min-h-[400px]">
        @if (isRevenueLoading()) { <app-individual-toaster></app-individual-toaster> }
        <div class="mb-6">
          <h3 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white flex items-center gap-2">
            Revenue Stream Mix
          </h3>
          <p class="text-[13px] text-slate-500 mt-[4px] mb-[13px]">Stacked monthly streams - Upfront - Downpayment -
            Late fee - Enrollment &middot; {{ formattedDateRange }}
          </p>
        </div>

        <div class="flex-grow w-full relative min-h-[300px]">
          @if (revenueStreamMixData().length > 0) {
          <app-multi-stacked-bar-chart [data]="revenueStreamMixData()" [legendData]="revenueLegend" [showLegend]="true"
            [showYAxis]="true" [showOnlyFirstLastXAxis]="true" [showXAxis]="true">
          </app-multi-stacked-bar-chart>
          } @else if (!isRevenueLoading()) {
          <div class="absolute inset-0 flex items-center justify-center text-slate-400 text-sm">
            No data available
          </div>
          }
        </div>
      </div>
    </div>
  </section>
</div>

<!-- Deep Dive Modal -->
@if (isDeepDiveModalOpen() && deepDiveData()) {
<div class="fixed inset-0 z-[9999] flex items-center justify-center">
  <!-- Backdrop -->
  <div class="absolute inset-0 bg-slate-900/40 dark:bg-slate-900/60 backdrop-blur-sm" (click)="closeDeepDiveModal()">
  </div>

  <!-- Modal Content -->
  <div
    class="relative bg-white dark:bg-slate-800 rounded-2xl shadow-2xl w-full max-w-[800px] max-h-[90vh] overflow-y-auto m-4 flex flex-col">
    <!-- Header -->
    <div
      class="px-6 py-5 border-b border-slate-100 dark:border-slate-700/50 flex items-start justify-between bg-slate-50/50 dark:bg-slate-800/50 rounded-t-2xl">
      <div>
        <div class="text-[10px] font-semibold tracking-[1.2px] text-purple-600 uppercase mb-1">
          Market deep-dive · {{ deepDiveData().isBizMode ? 'businesses' : 'contracts' }}
        </div>
        <h2 class="text-xl font-semibold text-slate-900 dark:text-white">
          {{ deepDiveData().regionName }}, {{ deepDiveData().countryLabel }}
        </h2>
      </div>
      <button (click)="closeDeepDiveModal()"
        class="w-8 h-8 flex items-center justify-center rounded-full bg-white dark:bg-slate-700 border border-slate-200 dark:border-slate-600 text-slate-500 hover:text-slate-900 hover:bg-slate-100 dark:hover:bg-slate-600 transition-colors">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="p-6">
      <!-- Hero Stats -->
      <div class="mb-6">
        <div class="text-2xl font-semibold text-slate-900 dark:text-white mb-1 tracking-tight">
          {{ (deepDiveData().isBizMode ? deepDiveData().activeBiz : deepDiveData().totalCon) | number }} {{
          deepDiveData().isBizMode ? 'active businesses' : 'contracts' }}
        </div>
        <div class="text-sm text-slate-500">
          {{ deepDiveData().segLabel }} · {{ (deepDiveData().isBizMode ? deepDiveData().totalCon :
          deepDiveData().totalBiz) | number }} {{ deepDiveData().isBizMode ? 'contracts originated in ' +
          deepDiveData().regionName : 'active businesses in ' + deepDiveData().regionName }}
        </div>
      </div>

      <!-- KPI Row -->
      <div class="grid grid-cols-4 gap-4 mb-6">
        <div class="bg-slate-50 dark:bg-slate-900/50 rounded-xl p-4 border border-slate-100 dark:border-slate-700/50">
          <div class="text-[10px] font-semibold text-slate-500 uppercase tracking-wider mb-2">
            {{ deepDiveData().isBizMode ? 'Total businesses' : 'Total contracts' }}
          </div>
          <div class="text-xl font-semibold text-slate-900 dark:text-white">
            {{ (deepDiveData().isBizMode ? deepDiveData().totalBiz : deepDiveData().totalCon) | number }}
          </div>
        </div>
        <div class="bg-slate-50 dark:bg-slate-900/50 rounded-xl p-4 border border-slate-100 dark:border-slate-700/50">
          <div class="text-[10px] font-semibold text-slate-500 uppercase tracking-wider mb-2">
            {{ deepDiveData().isBizMode ? 'New · last 30 days' : 'Last 30 days' }}
          </div>
          <div class="text-xl font-semibold text-slate-900 dark:text-white">
            {{ deepDiveData().last30 | number }}
          </div>
        </div>
        <div class="bg-slate-50 dark:bg-slate-900/50 rounded-xl p-4 border border-slate-100 dark:border-slate-700/50">
          <div class="text-[10px] font-semibold text-slate-500 uppercase tracking-wider mb-2">
            {{ deepDiveData().isBizMode ? 'New · last 7 days' : 'Last 7 days' }}
          </div>
          <div class="text-xl font-semibold text-slate-900 dark:text-white">
            {{ deepDiveData().last7 | number }}
          </div>
        </div>
        <div class="bg-slate-50 dark:bg-slate-900/50 rounded-xl p-4 border border-slate-100 dark:border-slate-700/50">
          <div class="text-[10px] font-semibold text-slate-500 uppercase tracking-wider mb-2">
            {{ deepDiveData().isBizMode ? 'Avg contracts / biz' : 'Top-8 financed' }}
          </div>
          <div class="text-xl font-semibold text-slate-900 dark:text-white">
            {{ deepDiveData().isBizMode ? (deepDiveData().avgContracts | number:'1.1-1') : ('$' +
            (deepDiveData().financedTotal/1000 | number:'1.0-0') + 'K') }}
          </div>
        </div>
      </div>

      <!-- Sparkline section -->
      <div class="mb-8">
        <div class="text-[10px] font-semibold text-purple-600 uppercase tracking-wider mb-3">
          {{ deepDiveData().isBizMode ? 'New businesses onboarded' : 'Contracts created' }} — last 30 days
        </div>
        <div
          class="bg-slate-50 dark:bg-slate-900/50 rounded-xl p-4 border border-slate-100 dark:border-slate-700/50 flex flex-col">
          <div class="w-full h-16 flex items-end justify-between gap-1 mb-3 relative">
            <!-- SVG line chart for sparkline -->
            <svg class="absolute inset-0 w-full h-full overflow-visible" viewBox="0 0 300 64"
              preserveAspectRatio="none">
              <defs>
                <linearGradient id="sparkline-gradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stop-color="#a855f7" stop-opacity="0.2"></stop>
                  <stop offset="100%" stop-color="#a855f7" stop-opacity="0"></stop>
                </linearGradient>
              </defs>
              <path [attr.d]="deepDiveData().sparklineArea" fill="url(#sparkline-gradient)"></path>
              <path [attr.d]="deepDiveData().sparklinePath" fill="none" stroke="#a855f7" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"></path>
              <circle [attr.cx]="300"
                [attr.cy]="deepDiveData().peak > 0 ? 64 - (deepDiveData().sparklineData[29] / deepDiveData().peak * 64 * 0.9) : 64"
                r="3" fill="#a855f7"></circle>
            </svg>
            <!-- Baseline line -->
            <div class="absolute bottom-0 left-0 w-full h-[2px] bg-purple-500"></div>
          </div>
          <div class="flex items-center justify-between text-[11px] text-purple-700 dark:text-purple-400">
            <span class="font-medium">30 DAYS · <b class="font-semibold">{{ deepDiveData().last30 | number }}</b>
              TOTAL</span>
            <span class="font-medium">PEAK <b class="font-semibold">{{ deepDiveData().peak | number }}</b>/DAY</span>
            <span class="font-medium">AVG <b class="font-semibold">{{ (deepDiveData().last30/30) | number:'1.1-1'
                }}</b>/DAY</span>
          </div>
        </div>
      </div>

      <!-- Table section -->
      <div>
        <div class="text-[10px] font-semibold text-purple-600 uppercase tracking-wider mb-3">
          Top businesses by contract volume
        </div>
        <div class="overflow-x-auto">
          <table class="w-full text-left">
            <thead>
              <tr class="border-b border-slate-200 dark:border-slate-700">
                <th class="py-2 px-2 text-[10px] font-semibold text-slate-500 uppercase tracking-wider w-8">#</th>
                <th class="py-2 px-4 text-[10px] font-semibold text-slate-500 uppercase tracking-wider">Business</th>
                <th class="py-2 px-4 text-[10px] font-semibold text-slate-500 uppercase tracking-wider">Category</th>
                <th class="py-2 px-4 text-[10px] font-semibold text-slate-500 uppercase tracking-wider">Industry</th>
                <th class="py-2 px-4 text-[10px] font-semibold text-slate-500 uppercase tracking-wider text-right">
                  Contracts</th>
                <th class="py-2 px-4 text-[10px] font-semibold text-slate-500 uppercase tracking-wider text-right">
                  Financed</th>
              </tr>
            </thead>
            <tbody>
              @for (biz of deepDiveData().topBusinesses; track biz.businessName; let i = $index) {
              <tr
                class="border-b border-slate-100 dark:border-slate-700/50 hover:bg-slate-50 dark:hover:bg-slate-800/50">
                <td class="py-2.5 px-2 text-xs text-slate-500 tabular-nums">{{ i + 1 }}</td>
                <td class="py-2.5 px-4 text-xs font-medium text-slate-900 dark:text-white">{{ biz.businessName }}</td>
                <td class="py-2.5 px-4">
                  <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium" [ngClass]="{
                              'bg-teal-50 text-teal-700 dark:bg-teal-500/10 dark:text-teal-400 border border-teal-200 dark:border-teal-800/50': biz.category === 'Dental',
                              'bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-400 border border-indigo-200 dark:border-indigo-800/50': biz.category === 'Healthcare',
                              'bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-400 border border-amber-200 dark:border-amber-800/50': biz.category === 'Non-Healthcare'
                            }">
                    {{ biz.category }}
                  </span>
                </td>
                <td class="py-2.5 px-4">
                  <span
                    class="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium bg-purple-50 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300">
                    {{ biz.industry }}
                  </span>
                </td>
                <td class="py-2.5 px-4 text-xs text-slate-700 dark:text-slate-300 tabular-nums text-right">{{
                  biz.total | number }}</td>
                <td class="py-2.5 px-4 text-xs text-slate-700 dark:text-slate-300 tabular-nums text-right">${{
                  biz.financed_amount/1000 | number:'1.1-1' }}K</td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
}